(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varmier-tracking"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('varmier-tracking')) {
    /**
     * Opens the carrier tracking page for the entered number in a new tab.
     * The tracking URL ends with the parameter prefix, e.g. https://t.17track.net/fr#nums=
     */
    class VarmierTracking extends HTMLElement {
      /** @type {AbortController | undefined} */
      #controller;

      connectedCallback() {
        this.#controller = new AbortController();
        this.querySelector('form')?.addEventListener('submit', this.handleSubmit, {
          signal: this.#controller.signal,
        });
      }

      disconnectedCallback() {
        this.#controller?.abort();
      }

      /** @param {SubmitEvent} event */
      handleSubmit = (event) => {
        const form = event.currentTarget;
        if (!(form instanceof HTMLFormElement)) return;

        const input = form.querySelector('input[name="nums"]');
        if (!(input instanceof HTMLInputElement)) return;

        const number = input.value.replace(/\s+/g, '');
        const base = this.dataset.trackingUrl ?? '';
        if (!number || !base) return;

        event.preventDefault();
        const url = `${base}${encodeURIComponent(number)}`;
        // window.open with the 'noopener' feature always returns null, so the opener is cut manually.
        const opened = window.open(url, '_blank');
        if (opened) {
          opened.opener = null;
        } else {
          window.location.assign(url);
        }
      };
    }

    customElements.define('varmier-tracking', VarmierTracking);
  }

  } catch(e) { console.error(e); }
})();
})();
